import * as XLSX from 'xlsx';
import { formatDocument } from 'shared/helpers/document';
import type { Cashback } from 'services/interfaces/cashback';

export function formatCurrencyBrl(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

/** Exibe data curta (dd/MM/yyyy) a partir de ISO ou yyyy-MM-dd */
export function formatDateShort(iso?: string): string {
  if (!iso) return '—';
  const slice = iso.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(slice)) {
    const [y, m, d] = slice.split('-');
    return `${d}/${m}/${y}`;
  }
  try {
    const dt = new Date(iso);
    if (Number.isNaN(dt.getTime())) return '—';
    return dt.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  } catch {
    return '—';
  }
}

export function exportCashbacksXlsx(
  rows: Cashback[],
  filename = 'cashbacks.xlsx',
) {
  const data = rows.map((row) => ({
    IDI: row.idi,
    'Data solicitação': formatDateShort(row.requested_at),
    Empresa: row.company_name,
    Documento: formatDocument(row.document),
    'Chave Pix': row.pix_key,
    Valor: row.cashback_amount,
    Status: row.paid ? 'Pago' : 'Pendente',
    'Data pagamento': formatDateShort(row.payment_date),
  }));

  const ws = XLSX.utils.json_to_sheet(data);

  const colWidths = [
    { wch: 10 },
    { wch: 16 },
    { wch: 30 },
    { wch: 20 },
    { wch: 24 },
    { wch: 14 },
    { wch: 12 },
    { wch: 16 },
  ];
  ws['!cols'] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Cashbacks');
  XLSX.writeFile(wb, filename);
}
